import { IconDefinition, faClock } from '@fortawesome/pro-regular-svg-icons';

import { STATUS_TO_ICON_MAP } from 'lib/common/constants/presenceStates';

const statusIcon = (status: string): IconDefinition => STATUS_TO_ICON_MAP[status] || faClock;

export default statusIcon;
